export default __webpack_public_path__ + "static/media/mobile-background-landscape.b190a1de.svg";